"use strict";

import { optimumFrictionConstants } from "../_constants/optimumFriction.constants";

export const INITIAL_OPTIMUM_FRICTION_STATE = {
     trainingPreview : null,
     trainingImportResult : null,
     report : null,
     reportExport : null,
     trainingImports : { imports: [], totalCount: 0 },
};

export function optimumFriction(state = INITIAL_OPTIMUM_FRICTION_STATE, action) {
    switch (action.type) {
     // A fresh preview clears the previous outcome, so a result can never sit above rows it was
     // not produced from.
     case optimumFrictionConstants.OPTIMUM_FRICTION_PREVIEW_TRAINING_IMPORT_COMPLETE:
          return {
               ...state,
               trainingPreview: action.payload || null,
               trainingImportResult: null,
          };

     case optimumFrictionConstants.OPTIMUM_FRICTION_COMMIT_TRAINING_IMPORT_COMPLETE:
          return {
               ...state,
               trainingImportResult: action.payload || null,
          };

     case optimumFrictionConstants.OPTIMUM_FRICTION_CLEAR_TRAINING_IMPORT:
          return {
               ...state,
               trainingPreview: null,
               trainingImportResult: null,
          };

     case optimumFrictionConstants.OPTIMUM_FRICTION_GET_TRAINING_IMPORTS_COMPLETE:
          return {
               ...state,
               trainingImports: action.payload,
          };

     case optimumFrictionConstants.OPTIMUM_FRICTION_GET_REPORT_COMPLETE:
          return {
               ...state,
               report: action.payload,
          };

     case optimumFrictionConstants.OPTIMUM_FRICTION_GET_REPORT_EXPORT_COMPLETE:
          return {
               ...state,
               reportExport: action.payload || null,
          };

     case optimumFrictionConstants.OPTIMUM_FRICTION_CLEAR_REPORT_EXPORT:
          return {
               ...state,
               reportExport: null,
          };

     default:
          return state;
    }
}
